const { fromHbDim } = require('./utils');

/** A single dimension in report-data used when updating HBA-data from adserver API data. */
class GranularDimension {
	/**
	 * @param {Object} settings - Settings for dimension
	 * @param {string} settings.unitName - Field-name in data returned by RtImporter.importHourlyDataSpecificInternal()
	 * @param {number} settings.group - report number to be included in, 0 is last report, 1 is second-to-last, etc
	 * @param {string} settings.hbDim - Name of HBA dimension
	 * @param {string} settings.desc - Description
	 * @param {boolean} settings.checkStringIncluded - If true, API-field must be ones of 'values' (see below)
	 * @param {string[]} settings.values - Allowed values for API-field when 'checkStringIncluded' is used.
	 */
	constructor(settings) {
		Object.assign(this, {
			...settings,
		});
		const { isAdsCustom } = this;
		if (!this.hbDim && isAdsCustom) {
			this.hbDim = this.name;
		}
		if (!this.hbDim) {
			throw Error('"hbDim" is missing');
		}
		if (!this.name) {
			this.name = this.hbDim;
		}
		if (!this.desc) {
			this.desc = isAdsCustom ? fromHbDim(this.name) : this.name;
		}
	}

	/** Convert API data value to corresponding values used in HBA reports (or null if not possible) */
	convertToValidUnitValue(val) {
		const { values, checkStringIncluded } = this;
		if (val === null || val === undefined) {
			return null;
		}
		if (values) {
			return values.find((v) => (checkStringIncluded ? val.includes(v) : v === val)) || null;
		}
		return val;
	}

	/** Used for "approximating" how to group dimensions in different reports */
	approxReportValues() {
		return (this.values?.length || this.approxNumValues || 0) + 1;
	}

	/** See RtImportState.getGroupingSignature() */
	groupingSignature({ crypto }) {
		return crypto.createHash('sha256').update(JSON.stringify([this.unitName, this.values])).digest('hex');
	}
}

module.exports = GranularDimension;
